import CreditCardInput from 'shared/components/molecules/CreditCardInput/CreditCardInput';
export * from './config';

export default CreditCardInput;
